import { Module } from 'vuex';

import { Instance } from 'qs_vuetify/src/types/models';
import { RootState } from 'qs_vuetify/src/types/states';

import { InstancesRestState } from '@/types/states';

import {
  buildRestActions,
  buildRestGetters,
  buildRestMutations,
  buildRestState,
} from 'qs_vuetify/src/plugins/rest';

export const state: InstancesRestState = buildRestState<Instance>('instances', {});

export const getters = buildRestGetters<Instance, InstancesRestState>();

export const actions = buildRestActions<Instance, InstancesRestState>();

export const mutations = buildRestMutations<Instance, InstancesRestState>();

export const instances: Module<InstancesRestState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
